export interface ShareCodeModalProps {
  albumName: string
  shareLoading: boolean
  shareError: string | null
  onGenerateCode: () => void
  onShareForViewing: () => void
  onClose: () => void
}

export default function ShareCodeModal({
  albumName,
  shareLoading,
  shareError,
  onGenerateCode,
  onShareForViewing,
  onClose,
}: ShareCodeModalProps) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>Share Album: {albumName}</h3>
        <p>Generate a sharing code for this album</p>
        <div className="modal-actions">
          <button
            onClick={onGenerateCode}
            disabled={shareLoading}
            className="primary-button"
          >
            {shareLoading ? 'Generating...' : 'Generate 7-day Code'}
          </button>
          <button className="secondary-button" onClick={onShareForViewing}>
            Share for viewing
          </button>
          <button onClick={onClose}>Cancel</button>
        </div>
        {shareError && <p className="error-message">Error: {shareError}</p>}
      </div>
    </div>
  )
}
